export default __webpack_public_path__ + "static/media/Abhishek Kumar.96834187.jpg";